import React, {useState, useCallback } from 'react';
import Cookies from 'js-cookie';
import { NavLink } from "react-router-dom";
// eslint-disable-next-line
import i18n from "../../i18n";
// eslint-disable-next-line
import i18next, { changeLanguage } from "i18next";
import { useTranslation } from 'react-i18next';
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap-v4-rtl/dist/css/bootstrap-rtl.min.css';
import "./NavBar.css";
import {Container ,Navbar ,Nav ,NavDropdown } from 'react-bootstrap';
import logo from '../../images/logo.png';
import {languages} from '../languages/languages';

function NavBar({ onDirChange}) {
  //save dir in cokkie for refresh
  let Cookieslan = Cookies.get('i18next');
  if(Cookieslan === 'en'){
    Cookieslan = 'ltr';
  }if(Cookieslan === 'ar'){
    Cookieslan = 'rtl';
  }
  //change dir and lang 
  const [dir, setDir] = useState(Cookieslan);

  const fun = useCallback((dir) => {
    onDirChange(dir)
  }, [setDir])
  
  const changeLanguage =  (lng , dir) => {
    i18n.changeLanguage(lng);
    setDir(dir);
    fun(dir);
   }
   const className =  dir ;
  const { t, i18n } = useTranslation();

  if(window.location.href==="https://jsource.sy/")
  {
    return (
      <>
  <Navbar  fixed="top"  bg="light" variant="light" expand="lg" >
<Container  fluid>
<Navbar.Brand href="#Hero" >
<img src={logo} width="40" height="40" alt='logo' className='mx-2' /><span className='logo'>JSource</span>
    </Navbar.Brand>
  <Navbar.Toggle  aria-controls="navbarScroll" />
  <Navbar.Collapse  >
    <Nav className=' my-2  my-lg-0' navbarScroll>
          <Nav.Link href='#Hero' >{t('Home')}</Nav.Link>
          <Nav.Link href="#services"> {t('Services')}</Nav.Link>
          <NavDropdown title={t('OurProjects')}>
              <NavDropdown.Item ><NavLink   to="/Alm7seb">{t('Alm7seb')}</NavLink ></NavDropdown.Item>
              <NavDropdown.Item ><NavLink   to="/Resturant">{t('Resturant')}</NavLink ></NavDropdown.Item>
          </NavDropdown>
          <Nav.Link href="#customers">{t('Customers')}</Nav.Link>
          <Nav.Link href="#about">{t('About')}</Nav.Link>
          <Nav.Link href="#contact">{t('Contact')}</Nav.Link>
          
          <div className='dropdown'>
            <button className="btn btn-light dropdown-toggle" type="button"  data-bs-toggle="dropdown" aria-expanded="false">
            <i className='bi bi-globe'></i>
            </button>
            <ul className="dropdown-menu" >
              {languages.map(({code , name , dir}) => (
               <li key={code}>
                 <button className='dropdown-item' onClick={() => changeLanguage(code , dir)} >{name}</button></li> 
              ))}
            </ul>
          </div>
          
    </Nav>  
  </Navbar.Collapse>
</Container>
</Navbar>
      </>
  )


  }else{

return (
        <>
    <Navbar  fixed="top"  bg="light" variant="light" expand="lg" >
  <Container  fluid>
  <Navbar.Brand href="/" >
  <img src={logo} width="40" height="40" alt='logo' className='mx-2' /><span className='logo'>JSource</span>
      </Navbar.Brand>
    <Navbar.Toggle  aria-controls="navbarScroll" />
    <Navbar.Collapse  >
      <Nav className=' my-2  my-lg-0' navbarScroll>
            <Nav.Link ><NavLink   to="/">{t('Home')}</NavLink ></Nav.Link>
            <Nav.Link ><NavLink to="/">{t('Services')}</NavLink> </Nav.Link>
            <NavDropdown title={t('OurProjects')}>
                <NavDropdown.Item ><NavLink   to="/Alm7seb">{t('Alm7seb')}</NavLink ></NavDropdown.Item>
                <NavDropdown.Item ><NavLink   to="/Resturant">{t('Resturant')}</NavLink ></NavDropdown.Item>
            </NavDropdown>
            <Nav.Link ><NavLink to="/"> {t('Customers')}</NavLink></Nav.Link>
            <Nav.Link ><NavLink to="/"> {t('About')}</NavLink></Nav.Link>
            <Nav.Link ><NavLink to="/"> {t('Contact')}</NavLink></Nav.Link>
            
            <div className='dropdown'>
              <button className="btn btn-light dropdown-toggle" type="button"  data-bs-toggle="dropdown" aria-expanded="false">
              <i className='bi bi-globe'></i>
              </button>
              <ul className="dropdown-menu" >
                {languages.map(({code , name , dir}) => (
                 <li key={code}>
                   <button className='dropdown-item' onClick={() => changeLanguage(code , dir)} >{name}</button></li> 
                ))}
              </ul>
            </div>
            
      </Nav>  
    </Navbar.Collapse>
  </Container>
</Navbar>
        </>
    )

  }

    
}

export default NavBar
